import { Button, Card, Col, Row, Space } from "antd";
import "./supervision-poject-card.scss";
import { useParams } from "react-router-dom";
import { useNavigate, routes } from "@shared/lib/react-router";
import { SupervisionProject } from "./types";

interface Props {
  project: SupervisionProject;
}

export const SupervisionProjectCard = ({ project }: Props) => {
  const { projectId } = useParams();
  const item = project;
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(routes.supervision.notifications(projectId, item.supervisionId));
  };
  return (
    <Card className="project-card" bordered onClick={() => handleClick()}> 
      <Row gutter={16} align="middle" justify="space-between">
        <Col flex="auto" className="project-card__left">
          <Space direction="vertical" size={0} className="project-meta">
            <div className="project-title">{item.title}</div>
            <div className="project-subtitle">{item.address}</div>
            {item.authority ? (
              <div className="project-authority">{item.authority}</div>
            ) : null}
          </Space>
        </Col>
        <Col flex="0 0 40%" className="project-card__right">
          {item.right.type === "counters" ? (
            <div className="right-block right-block--list">
              <div className="right-block__row">
                <span className="right-label">Входящих документов</span>
                <span className="count-badge">{item.right.incoming}</span>
              </div>
              <div className="right-block__row">
                <span className="right-label">Исходящих документов</span>
                <span className="count-badge">{item.right.outgoing}</span>
              </div>
              <div className="right-block__row">
                <span className="right-label">На обработку</span>
                <span className="count-badge">{item.right.processing}</span>
              </div>
            </div>
          ) : null}

          {item.right.type === "action" ? (
            <div className="right-block right-block--action">
              <div className="right-block__message">{item.right.message}</div>
              <Button type="primary">{item.right.actionText}</Button>
            </div>
          ) : null}
        </Col>
      </Row>
    </Card>
  );
};

